import { Injectable, inject, DOCUMENT } from '@angular/core';
import { Store } from '@ngxs/store';
import { NotificationType } from './symbols';
import { NotificationState } from './notification.state';
import { ClearNotificationsByType, ClearLocalNotifications, GetMyNotifications, ClearNotificationsByUnit } from './notification.actions';
import { tap, takeUntil, delay, filter } from 'rxjs/operators';
import { timer } from 'rxjs';
import { Client } from '@appbolaget/aware-model';
import { Config } from '@services/config';
import { AwareAuthService } from '@appbolaget/aware-auth';


@Injectable({ providedIn: 'root' })
export class NotificationService {
    private store = inject(Store);
    private config = inject(Config);

    IS_LISTENING: boolean;

    #document = inject(DOCUMENT);
    private awareAuth = inject(AwareAuthService);

    constructor() {
        this._initListeners();
    }

    checkNotificationsForType(type: NotificationType) {
        const notifications = this.store.selectSnapshot(NotificationState.notificationsByType(type));

        if (notifications && notifications.length) {
            this.store.dispatch(new ClearNotificationsByType(type));
        }
    }

    checkNotificationsForUnit(unit_id: number, unit_uuid: string) {
        const notifications = this.store.selectSnapshot(NotificationState.notificationsByUnit(unit_id));

        if (notifications && notifications.length) {
            this.store.dispatch(new ClearNotificationsByUnit(unit_uuid));
        }
    }

    private _initListeners() {
        this.awareAuth.onLogout$
            .pipe(
                tap((_) => {
                    this.IS_LISTENING = false;
                    this.store.dispatch(new ClearLocalNotifications());
                }),
            )
            .subscribe();

        this.awareAuth.client$
            .pipe(
                delay(3000),
                filter((client) => client instanceof Client && !this.IS_LISTENING),
                tap(() => {
                    this._startNotificationListener();
                }),
            )
            .subscribe();
    }

    private _startNotificationListener() {
        if (this.IS_LISTENING) {
            return;
        }

        if (!this.config.get('unitConfig.panel.notifications.enabled')) {
            return;
        }

        this.IS_LISTENING = true;

        timer(0, 40000)
            .pipe(
                takeUntil(this.awareAuth.onLogout$),
                filter(() => this.#document.visibilityState === 'visible'),
                tap((_) => {
                    this.store.dispatch(new GetMyNotifications());
                }),
            )
            .subscribe();
    }
}
